module.exports = __webpack_public_path__ + "img/spirit_brown_ba_list.022fac10.jpg";